// To see this message, add the following to the `<head>` section in your
// views/layouts/application.html.erb
//
//    <%= vite_client_tag %>
//    <%= vite_javascript_tag 'application' %>
console.log("Vite ⚡️ Rails");

// If using a TypeScript entrypoint file:
//     <%= vite_typescript_tag 'application' %>
//
// If you want to use .jsx or .tsx, add the extension:
//     <%= vite_javascript_tag 'application.jsx' %>

// Example: Load Rails libraries in Vite.
//
// import * as Turbo from '@hotwired/turbo'
// Turbo.start()
//
// import ActiveStorage from '@rails/activestorage'
// ActiveStorage.start()
//
// // Import all channels.
// const channels = import.meta.globEager('./**/*_channel.js')

// Example: Import a stylesheet in app/frontend/index.css
// import '~/index.css'

import "@hotwired/turbo-rails";
import "trix";
import "@rails/actiontext";

// Setup full toolbar for editors that need all buttons
function setupFullToolbarEditors() {
  document.querySelectorAll('trix-editor.trix-editor--full-toolbar').forEach(editor => {
    const toolbar = editor.toolbarElement;
    if (toolbar) {
      toolbar.classList.add('trix-toolbar--full');
      // Ensure all button groups are visible
      const groups = toolbar.querySelectorAll('.trix-button-group');
      groups.forEach(group => {
        group.style.display = 'flex';
      });
    }
  });
}

document.addEventListener("turbo:load", () => {
  console.log("Turbo loaded!");
  setupFullToolbarEditors();
});

// Also run on DOMContentLoaded for non-Turbo pages
document.addEventListener('DOMContentLoaded', setupFullToolbarEditors);

// Observe for dynamically added trix editors
if (typeof MutationObserver !== 'undefined') {
  const observer = new MutationObserver(() => {
    setupFullToolbarEditors();
  });
  observer.observe(document.body, { childList: true, subtree: true });
}

// <turbo-stream action="redirect" target="/projects"><template></template></turbo-stream>
// turbo_stream.action(:redirect, projects_path)
Turbo.StreamActions.redirect = function () {
  Turbo.visit(this.target);
};

import "../controllers";
import "../channels";

// Import markdown toolbar element at the application level
import "@github/markdown-toolbar-element";
